import { getAuth, signInWithPopup } from 'firebase/auth';
import { GoogleAuthProvider } from 'firebase/auth';
import React, { useState } from 'react';
import { FcGoogle } from "react-icons/fc";
import { toast } from 'react-toastify';
import { db } from '../firebase';
import { doc, getDoc, serverTimestamp, setDoc, getDocs, query, collection, where } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

export default function OAuth() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Function to generate username from name
  async function generateUsername(name) {
    // Convert to lowercase and replace spaces with dots
    let baseUsername = name.toLowerCase().replace(/\s+/g, '.');
    
    // Remove special characters, keep only letters and numbers
    baseUsername = baseUsername.replace(/[^a-z0-9.]/g, '');
    
    // Check if username exists and generate unique username
    let finalUsername = baseUsername;
    let usernameExists = true;
    let counter = 0;

    while (usernameExists) {
      const q = query(collection(db, "users"), where("username", "==", finalUsername));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        usernameExists = false;
      } else {
        counter++;
        finalUsername = `${baseUsername}${counter}`;
      }
    }

    return finalUsername;
  }

  async function onGoogleClick() {
    try {
      setIsLoading(true);
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Check for the user
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        // Generate username from Google display name
        const username = await generateUsername(user.displayName);
        
        await setDoc(docRef, {
          name: user.displayName,
          email: user.email,
          username: username,
          timestamp: serverTimestamp(),
          photoURL: user.photoURL,
          verified: false // Add verification status, default to false
        });
        
        // Navigate to profile image upload page instead of home
        navigate("/add-profile-image");
      } else {
        // If user exists, go directly to home
        navigate("/");
      }

    } catch (error) {
      toast.error("Could not authorize with Google");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <button
      type="button" 
      onClick={onGoogleClick} 
      disabled={isLoading}
      className="flex items-center justify-center w-full 
      bg-white text-black px-7 py-3 
      uppercase text-sm font-bold hover:bg-gray-700 
      active:bg-blue-800 shadow-md hover:shadow-lg active:shadow-lg 
      transition duration-150 ease-in-out rounded-full"
    >
      {isLoading ? (
        <>
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          AWEIT AI VERIFYING...
        </>
      ) : (
        <>
          <FcGoogle className="text-2xl mr-2"/>
          Continue with Google
        </>
      )}
    </button>
  );
}